<template>
  <!-- 组织架构 -->
  <div class="organizationContentOne">
    <div v-show="lizhiPeopleShow">
      <div class="title-title">
        <span class="title">{{ titleObj.structureName }}</span>
        <span v-show="titleObj.parentId == 0"
          >( {{ titleObj.peopleNum }}人 )</span
        >
        <Button
          type="success"
          class="fourSize"
          v-show="titleObj.parentId !== 0"
          @click="changgeBumen(1)"
          ghost
          >修改部门</Button
        >

        <Button class="title-btn fourSize" type="success" ghost @click="piLiang"
          >导出</Button
        >
      </div>
      <div class="title-cont" v-show="titleObj.parentId !== 0">
        <span v-for="(item, index) in titleList" :key="index">
          <span :class="{ titleactive: index == titleList.length - 1 }">
            {{ item.structureName }}</span
          >
          <Icon
            v-show="index !== titleList.length - 1"
            class="title-icon"
            type="ios-arrow-forward"
          />
        </span>
      </div>
      <div class="title-title">
        <span class="title">下级部门</span>
        <Button type="success" class="fiveSize" ghost @click="changgeBumen(2)"
          >新增下级部门</Button
        >
        <Button
          type="success"
          class="fiveSize"
          v-show="titleObj.parentId !== 0"
          style="margin-left:10px;"
          ghost
          @click="goback(2)"
          >返回上级部门</Button
        >
      </div>
      <ul class="buttom-bu xianzhi" v-show="clubList.length > 0">
        <li
          v-for="(item, index) in clubList"
          :key="index"
          @click="totreenode(item, index)"
        >
          <span class="name">{{ item.structureName }}</span>
          <span class="peaple">{{ item.peopleNum }} （人） </span>
          <Icon class="title-icon" type="ios-arrow-forward" />
        </li>
      </ul>
      <div class="buttom-bu" v-show="clubList.length == 0">
        <img class="buttom-bu-img" src="../img/kong.jpg" alt="" />
        <div style="width:100%;text-align:center;margin-top:15px;">
          无相关下级部门
        </div>
      </div>
      <div class="title-title title-title-margin">
        <span class="title">人员列表</span>
        <Button type="success" ghost @click="addMember" class="fourSize"
          >新增成员</Button
        >
        <Button
          type="success"
          ghost
          @click="sliceIMember"
          class="fourSize"
          style="margin-left:15px;"
          >成员离职</Button
        >
        <Checkbox class="title-btn" v-model="single" @on-change="changgesingle"
          >显示下级所有部门人员</Checkbox
        >
      </div>
      <div class="organizationContentOne-tablie">
        <Table
          stripe
          @on-selection-change="selectChange"
          :columns="columns4"
          :data="data"
          @on-sort-change="changesort"
        ></Table>
      </div>
      <div class="page-div">
        <div class="page-div-left">
          已选 <span>{{ selectNum }}</span> 条
        </div>
        <Page
          @on-page-size-change="changepage"
          :total="tableObj.total"
          show-elevator
          show-total
          @on-change="changecurrent"
          :current="current"
          :page-size="pageSize"
          show-sizer
          class="page-div-page"
        />
      </div>
    </div>

    <div v-show="!lizhiPeopleShow">
      <div class="title-title">
        <span class="title">离职员工</span>
        <span style="margin-left:55px;"
          >已离职员工角色只做为记录，并不具有可操作权限</span
        >
        <Button
          class="title-btn fourSize"
          type="success"
          ghost
          @click="peoplePiLiang"
          >导出</Button
        >
      </div>
      <div class="organizationContentOne-tablie">
        <Table
          stripe
          @on-selection-change="selectChangepeople"
          :columns="columns"
          :data="people"
          @on-sort-change="changesortPeople"
        ></Table>
      </div>
      <div class="page-div">
        <div class="page-div-left page-div-lefts">
          已选 <span>{{ peopleselectNum }}</span> 条
        </div>
        <Button
          class="title-btn fourSize"
          type="success"
          ghost
          @click="seletPeople"
          >删除</Button
        >
        <Page
          @on-page-size-change="changepeoplepage"
          :total="peopletotal"
          show-elevator
          show-total
          @on-change="changePeoplecurrent"
          :current="peoplepageNum"
          :page-size="peoplepageSize"
          show-sizer
          class="page-div-page"
        />
      </div>
    </div>
    <Alert class="alertTitle" v-show="alertTitleIshow" show-icon type="success"
      >操作成功</Alert
    >
    <Alert
      class="alertTitle"
      v-show="alertTitleIshow2"
      type="error"
      show-icon
      >{{ alertTitle }}</Alert
    >

    <!-- <Spin fix v-show="isiconfontshow">
      <span class="iconfont demo-spin-icon-load ivu-icon">&#xe71d;</span>
      <div>距离有些遥远，小简 正在努力中……</div>
    </Spin> -->
    <!-- 修改部门 和新增下级部门 -->
    <Modal
      class="bumenModal ivumodal"
      width="500"
      v-model="bumen"
      footer-hide
      :title="xiugaiTitle"
      @on-ok="ok"
      @on-cancel="cancel"
    >
      <ChangeBumen
        ref="ChangeBumen"
        :titleObj="titleObj"
        :bumen="bumen"
        @changeBumen="changeBumen"
      ></ChangeBumen>
    </Modal>
    <!-- 新增成员 -->
    <Modal
      class="ivumodal"
      v-model="memberShow"
      width="500"
      footer-hide
      title="新增成员"
      @on-ok="ok"
      @on-cancel="cancel"
    >
      <Addmember ref="Addmember" @setMemberShow="setMemberShow"></Addmember>
    </Modal>
    <!-- 修改成员 -->
    <Modal
      class="ivumodal"
      v-model="xiugaimemberShow"
      width="500"
      footer-hide
      title="修改成员"
      @on-ok="ok"
      @on-cancel="cancel"
    >
      <Xiugaimember
        ref="Xiugaimember"
        @setxiugaiMemberShow="setxiugaiMemberShow"
      ></Xiugaimember>
    </Modal>
    <!-- 成员离职弹框 -->
    <Modal
      class="ivumodal"
      width="500"
      footer-hide
      v-model="sliceIshhow"
      :title="titlename"
    >
      <div class="ivumodal-cont" v-show="title == '请选择需要操作的数据'">
        {{ title }}
      </div>
      <div class="selectdata" v-show="title !== '请选择需要操作的数据'">
        <div class="numtitle">选择数量：{{ selectNum }} 条</div>
        <Form
          ref="liZhidata"
          :model="liZhidata"
          :rules="ruleliZhidata"
          :label-width="130"
        >
          <FormItem label="离职日期：" prop="data" class="bumenModal-item">
            <DatePicker
              :editable="false"
              style="width: 300px"
              v-model="liZhidata.data"
              type="date"
              placeholder="请选择离职日期"
            ></DatePicker>
          </FormItem>
        </Form>
      </div>
      <div class="secondBumen-bottom">
        <Button
          class="btn"
          type="success"
          ghost
          @click="handleReset('liZhidata')"
          >取消</Button
        >
        <Button
          class="btn sure"
          type="success"
          ghost
          @click="handleSubmit('liZhidata')"
          >确定</Button
        >
      </div>
    </Modal>
    <!-- 表格离职交接弹框 -->
    <Modal
      v-model="lizhiShow"
      footer-hide
      title="离职交接"
      @on-ok="ok"
      @on-cancel="cancel"
    >
      <ChangeLizhi @lizhiSure="lizhiSure"></ChangeLizhi>
    </Modal>
    <!-- 离职交接详情（离职人员） -->
    <Modal
      v-model="lizhixiangqingPeopleShow"
      title="离职交接详情"
      class="ivumodal"
      footer-hide
    >
      <People></People>
      <div class="secondBumen-bottom">
        <Button class="btn" type="success" ghost @click="peoplenone"
          >取消</Button
        >
        <Button class="btn sure" type="success" ghost @click="peoplenone"
          >确定</Button
        >
      </div>
    </Modal>
    <!-- 删除部门 -->
    <Modal
      class="ivumodal"
      v-model="sliceIBumen"
      :title="titlename"
      footer-hide
    >
      <div class="ivumodal-cont">
        确认需要执行删除操作？
      </div>
      <div class="secondBumen-bottom">
        <Button class="btn" type="success" ghost @click="sliceIBumencancel"
          >取消</Button
        >
        <Button class="btn sure" type="success" ghost @click="sliceIBumenok"
          >确定</Button
        >
      </div>
    </Modal>
    <!-- 删除离职人员 -->
    <Modal
      class="ivumodal"
      v-model="sliceILizhi"
      :title="titlename"
      footer-hide
    >
      <div class="ivumodal-cont">
        选中内容确实需要执行删除操作？
      </div>
      <div class="secondBumen-bottom">
        <Button class="btn" type="success" ghost @click="sliceILizhicancel"
          >取消</Button
        >
        <Button class="btn sure" type="success" ghost @click="sliceILizhiok"
          >确定</Button
        >
      </div>
    </Modal>
  </div>
</template>
<script>
    import ChangeBumen from "../tan/changeBumen";
    import ChangeLizhi from "../tan/changeLizhi";
    import Addmember from "../tan/addmember";
    import Xiugaimember from "../tan/xiugaimember";
    import People from "../tan/people";
    import {
        updateUserInfoById,
        deleteStructure,
        deleteSeparatedEmployee,
        getSeparatedEmployeeList,
        getSubordinateList,
        exportUserList,
        getUserListByStructureId,
        addStructure,
        updateStructure,
        addUser,
        addSeparatedEmployee
    } from "../servers/api";
    // import { loadavg } from 'os';
    export default {
        name: "organizationContentOne",
        props: {
            toChildId: Number
        },
        data() {
            return {
                xiugaimemberShow: false,
                alertTitle: "",
                alertTitleIshow: false, //弹框成功失败提示
                alertTitleIshow2: false,
                liZhidataData: "",
                liZhidata: {
                    //成员离职日期
                    data: ""
                },
                ruleliZhidata: {
                    data: [{
                        required: true,
                        message: "请选择离职日期"
                    }]
                },
                isiconfontshow: false, //控制请求接口动画显示
                sliceILizhi: false,
                titlename: "成员离职",
                sliceIBumen: false, //删除部门
                lizhiPeopleShow: false, //离职员工列表
                xiugaiTitle: "修改部门",
                clubList: [],
                single: false,
                singleitem: 0,
                current: 1,
                peoplecurrent: 1,
                people: [],
                columns: [{
                        type: "selection",
                        width: 70,
                        align: "center"
                    }, {
                        title: "人员来源",
                        align: "center",
                        ellipsis: true,
                        key: "sourceName",
                        sortable: true
                    }, {
                        title: "姓名",
                        // width: 90,
                        align: "center",
                        ellipsis: true,
                        key: "userName",
                        sortable: true
                    }, {
                        title: "部门",
                        align: "center",
                        ellipsis: true,
                        sortable: true,
                        key: "structureName"
                    }, {
                        title: "职位",
                        align: "center",
                        ellipsis: true,
                        sortable: true,
                        key: "position"
                    }, {
                        title: "离职日期",
                        align: "center",
                        ellipsis: true,
                        sortable: true,
                        key: "separatedDate",
                        render: (h, params) => {
                            let name = "";
                            if (params.row.separatedDate) {
                                name = params.row.separatedDate.slice(0, 10);
                            }

                            return h("div", [
                                h(
                                    "span", {
                                        style: {
                                            display: "inline-block",
                                            width: "100%",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap"
                                        }
                                    },
                                    name
                                )
                            ]);
                        }
                    }

                    // {
                    //     title: '离职交接',
                    //     align: 'center',
                    //     key: 'awssd',
                    //     width: 100,
                    //     render:(h,params)=>{
                    //         return h('div', {
                    //             style:{
                    //                 // width:'80px',
                    //                 height:'30px',
                    //                 'line-height':'30px',
                    //                 'text-align':'center',
                    //                 'font-size':'13px',
                    //                 background:'#fff',
                    //                 border:'1px solid #53CAC3',
                    //                 'border-radius':'5px'
                    //             },
                    //             on: {
                    //                 click: () => {
                    //                 //    this.toPeopleJiaojie(params.row)
                    //                 }
                    //             }
                    //         }, '交接清单')
                    //     }
                    // },
                ],
                lizhixiangqingPeopleShow: false,
                peopletotal: 0, //总条数
                peoplepageSize: 20,
                peoplepageNum: 1,
                orderField: "", //人员离职排序的参数名字
                isAsc: "", //人员离职排序的参数升序降序
                peopleselectNum: 0, //离职有人缘已选
                peopleSelectList: [], //离职员工多选存储
                data: [],
                columns4: [{
                        type: "selection",
                        width: 70,
                        align: "center"
                    }, {
                        title: "人员来源",
                        align: "center",
                        ellipsis: true,
                        key: "sourceName",
                        sortable: true
                    }, {
                        title: "姓名",
                        // width: 90,
                        align: "center",
                        ellipsis: true,
                        key: "userName",
                        sortable: true
                    }, {
                        title: "部门",
                        align: "center",
                        ellipsis: true,
                        sortable: true,
                        key: "structureName",
                        render: (h, params) => {
                            return h("div", [
                                h(
                                    "span", {
                                        style: {
                                            display: "inline-block",
                                            width: "100%",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap"
                                        },
                                        domProps: {
                                            title: params.row.structureName
                                        }
                                    },
                                    params.row.structureName
                                )
                            ]);
                        }
                    }, {
                        title: "职位",
                        align: "center",
                        ellipsis: true,
                        sortable: true,
                        key: "position"
                    }, {
                        title: "手机号",
                        align: "center",
                        ellipsis: true,
                        sortable: true,
                        key: "phone"
                    }, {
                        title: "操作",
                        align: "center",
                        key: "awssd",
                        width: 100,
                        render: (h, params) => {
                            return h(
                                "div", {
                                    style: {
                                        width: "50px",
                                        height: "28px",
                                        "line-height": "30px",
                                        "text-align": "center",
                                        "font-size": "13px",
                                        background: "#fff",
                                        border: "1px solid #53CAC3",
                                        "border-radius": "5px",
                                        "margin-left": "8px",
                                        cursor: "pointer"
                                    },
                                    on: {
                                        click: () => {
                                            this.addMember(params.row, 1);
                                        }
                                    }
                                },
                                "修改"
                            );
                        }
                    }
                    // {
                    //     title: '离职交接',
                    //     align: 'center',
                    //     key: 'awssd',
                    //     width: 100,
                    //     render:(h,params)=>{
                    //         return h('div', {
                    //             style:{
                    //                 // width:'50px',
                    //                 height:'30px',
                    //                 'line-height':'30px',
                    //                 'text-align':'center',
                    //                 'font-size':'13px',
                    //                 background:'#fff',
                    //                 border:'1px solid #53CAC3',
                    //                 'border-radius':'5px'
                    //             },
                    //             on: {
                    //                 click: () => {
                    //                 //    this.toJiaojie(params.row)
                    //                 }
                    //             }
                    //         }, '离职交接')
                    //     }
                    // },
                ],
                lizhiShow: false, //离职交接弹框
                bumen: false, //部门弹框
                memberShow: false, //新增成员
                sliceIshhow: false, //成员离职
                title: "选中的成员确实需要执行离职操作？", //请选择需要操作的数据
                tableObj: {},
                pageSize: 20,
                titleObj: {}, //树形点击
                titleList: [],
                selectList: [], //选中得table
                selectNum: 0, //选择多少
                paixuKey: "", //排序得参数key值
                paixuSc: "", //排序得参数升序降序
                toChildIdnum: "",
                clearParentId: "" //删除部门传来的父级id 存储
            };
        },
        components: {
            ChangeBumen,
            ChangeLizhi,
            Addmember,
            People,
            Xiugaimember
        },
        created() {
            this.getSubordinateLists();
            this.getUserListByStructureIds();
        },
        methods: {
            goback() {
                //返回上级部门
                this.$emit("getoneTotree", this.titleList[this.titleList.length - 2]);
            },
            totreenode(item, index) {
                //点击下级部门的选项 进行左侧菜单数据切换
                this.$emit("getoneTotree", item);
            },
            changeBumen(res, objs) {
                //子组件传来部门弹框的关闭 且调去新增或者修改接口;
                if (res == false) {
                    this.bumen = false;
                    return;
                }
                if (res == "删除") {
                    this.clearParentId = objs;
                    this.sliceIBumen = true;
                    return;
                }
                if (res.index == 2) {
                    //新增下级
                    let postid = res.transferfromItem.id;
                    let params = {
                        parentId: res.transferfromItem.id,
                        structureName: res.data.name
                    };
                    this.isiconfontshow = true;
                    addStructure(params).then(res => {
                        if (res.data.code == 1) {
                            this.isiconfontshow = false;
                            this.bumen = false;
                            this.alertTitleIshow = true;
                            setTimeout(() => {
                                this.alertTitleIshow = false;
                            }, 2000);
                            this.getSubordinateLists(this.titleObj.id);
                            this.$emit("gettrees", true, postid); //通知tree调取接口传添加的父级id
                        } else {
                            this.isiconfontshow = false;
                            this.alertTitle = res.data.msg;
                            this.alertTitleIshow2 = true;
                            setTimeout(() => {
                                this.alertTitleIshow2 = false;
                            }, 2000);
                        }
                    });
                } else {
                    //修改部门信息
                    let structureId = "";
                    if (res.transferfromItem && res.transferfromItem.id) {
                        structureId = res.transferfromItem.id;
                    } else {
                        structureId = res.data.parentId;
                    }
                    let params = {
                        structureId: res.data.sessionId,
                        parentId: structureId,
                        structureName: res.data.name
                    };
                    this.isiconfontshow = true;
                    updateStructure(params).then(res => {
                        if (res.data.code == 1) {
                            this.isiconfontshow = false;
                            this.bumen = false;
                            this.alertTitleIshow = true;
                            setTimeout(() => {
                                this.alertTitleIshow = false;
                            }, 2000);
                            this.getSubordinateLists(this.titleObj.id);
                            this.$emit("gettrees", true, structureId, params.structureId); //通知tree调取接口
                        } else {
                            this.isiconfontshow = false;
                            this.alertTitle = res.data.msg;
                            this.alertTitleIshow2 = true;
                            setTimeout(() => {
                                this.alertTitleIshow2 = false;
                            }, 2000);
                        }
                    });
                }
            },
            changgeBumen(index) {
                //修改部门

                if (index == 1) {
                    //修改部门
                    this.xiugaiTitle = "修改部门";
                    this.bumen = true;
                    let sessionId = "";
                    let structureName = "";
                    if (this.titleList.length == 1 || this.titleList.length == 2) {
                        sessionId = this.titleList[0].id;
                        structureName = this.titleList[0].structureName;
                    } else {
                        sessionId = this.titleList[this.titleList.length - 2].id;
                        structureName = this.titleList[this.titleList.length - 2]
                            .structureName;
                    }
                    let params = {
                        formValidate: {
                            name: this.titleObj.structureName, //部门名称
                            city: structureName, //上级部门名称
                            parentId: sessionId, //父级部门id
                            sessionId: this.titleObj.id //部门id
                        },
                        index: index, //1为修改部门
                        isDelet: true
                    };
                    this.$refs.ChangeBumen.gettitleobj(params);
                } else {
                    //新增下级部门
                    this.xiugaiTitle = "新增下级部门";
                    this.bumen = true;
                    let sessionId = "";
                    let structureName = "";
                    let benid = "";
                    let benname = "";
                    if (this.titleList.length == 1) {
                        sessionId = this.titleList[0].id;
                        structureName = this.titleList[0].structureName;
                        benname = this.titleList[0].structureName;
                        benid = this.titleList[0].id;
                    } else if (this.titleList.length == 2) {
                        sessionId = this.titleList[0].id;
                        structureName = this.titleList[0].structureName;
                        benname = this.titleList[1].structureName;
                        benid = this.titleList[1].id;
                    } else {
                        sessionId = this.titleList[this.titleList.length - 2].id;
                        structureName = this.titleList[this.titleList.length - 2]
                            .structureName;
                        benname = this.titleList[this.titleList.length - 1].structureName;
                        benid = this.titleList[this.titleList.length - 1].id;
                    }
                    let params = {
                        formValidate: {
                            name: "", //部门名称
                            city: structureName, //上级部门名称
                            benid: benid,
                            benname: benname,
                            parentId: sessionId, //父级部门id
                            sessionId: "" //部门id
                        },
                        index: index,
                        isDelet: false
                    };
                    this.$refs.ChangeBumen.gettitleobj(params);
                }
            },
            setxiugaiMemberShow(res) {
                if (res == false) {
                    this.xiugaimemberShow = false;
                } else {
                    let params = {
                        userName: res.formValidate.name,
                        structureIdList: res.rightListItem.id,
                        position: res.formValidate.position,
                        phone: res.formValidate.tel,
                        userId: res.formValidate.userId
                    };
                    this.isiconfontshow = true;
                    updateUserInfoById(params).then(res => {
                        if (res.data.code == 1) {
                            this.isiconfontshow = false;
                            this.xiugaimemberShow = false;
                            this.getUserListByStructureIds(this.titleObj.id); //添加成员成功后重新调取人员列表
                            this.alertTitleIshow = true;
                            setTimeout(() => {
                                this.alertTitleIshow = false;
                            }, 2000);
                        } else {
                            this.isiconfontshow = false;
                            this.alertTitle = res.data.msg;
                            this.alertTitleIshow2 = true;
                            setTimeout(() => {
                                this.alertTitleIshow2 = false;
                            }, 2000);
                        }
                    });
                }
            },
            addMember(item, index) {
                //新增成员
                if (index == 1) {
                    //修改成员
                    let sessionId = "";
                    let structureName = "";
                    let benid = "";
                    let benname = "";
                    if (this.titleList.length == 1) {
                        sessionId = this.titleList[0].id;
                        structureName = this.titleList[0].structureName;
                        benid = this.titleList[0].id;
                        benname = this.titleList[0].structureName;
                    } else if (this.titleList.length == 2) {
                        sessionId = this.titleList[0].id;
                        structureName = this.titleList[0].structureName;
                        benid = this.titleList[1].id;
                        benname = this.titleList[1].structureName;
                    } else {
                        sessionId = this.titleList[this.titleList.length - 2].id;
                        structureName = this.titleList[this.titleList.length - 2]
                            .structureName;
                        benid = this.titleList[this.titleList.length - 1].id;
                        benname = this.titleList[this.titleList.length - 1].structureName;
                    }
                    item.city = structureName;
                    item.parentId = sessionId;
                    item.benid = benid;
                    item.benname = benname;
                    this.$refs.Xiugaimember.gettitleobj(this.titleObj, item);
                    this.xiugaimemberShow = true;
                } else {
                    this.memberShow = true;
                    let sessionId = "";
                    let structureName = "";
                    let benid = "";
                    let benname = "";
                    if (this.titleList.length == 1) {
                        sessionId = this.titleList[0].id;
                        structureName = this.titleList[0].structureName;
                        benid = this.titleList[0].id;
                        benname = this.titleList[0].structureName;
                    } else if (this.titleList.length == 2) {
                        sessionId = this.titleList[0].id;
                        structureName = this.titleList[0].structureName;
                        benid = this.titleList[1].id;
                        benname = this.titleList[1].structureName;
                    } else {
                        sessionId = this.titleList[this.titleList.length - 2].id;
                        structureName = this.titleList[this.titleList.length - 2]
                            .structureName;
                        benid = this.titleList[this.titleList.length - 1].id;
                        benname = this.titleList[this.titleList.length - 1].structureName;
                    }
                    let params = {
                        formValidate: {
                            city: structureName, //上级部门名称
                            parentId: sessionId, //父级部门id
                            benid: benid,
                            benname: benname
                        }
                    };
                    this.$refs.Addmember.gettitleobj(this.titleObj, params); //传给addmember当前点击得树形信息
                }
            },
            setMemberShow(res) {
                //控制添加成员弹框接收子组件传值
                //addmember传来得值 trye和false显示隐藏
                if (res == false) {
                    this.memberShow = false;
                } else {
                    let params = {
                        loginName: res.formValidate.name,
                        structureIdList: res.rightListItem.id,
                        position: res.formValidate.position,
                        phone: res.formValidate.tel
                    };
                    this.isiconfontshow = true;
                    addUser(params).then(res => {
                        if (res.data.code == 1) {
                            this.isiconfontshow = false;
                            this.memberShow = false;
                            this.getUserListByStructureIds(this.titleObj.id); //添加成员成功后重新调取人员列表
                            this.alertTitleIshow = true;
                            setTimeout(() => {
                                this.alertTitleIshow = false;
                            }, 2000);
                        } else {
                            this.isiconfontshow = false;
                            this.alertTitle = res.data.msg;
                            this.alertTitleIshow2 = true;
                            setTimeout(() => {
                                this.alertTitleIshow2 = false;
                            }, 2000);
                        }
                    });
                }
            },
            changepage(num) {
                //liaobiao切换请求条数
                this.pageSize = num;
                this.current = 1;
                this.getUserListByStructureIds(this.toChildIdnum);
            },
            changepeoplepage(num) {
                //离职人员切换请求条数
                this.peoplepageSize = num;
                this.peoplepageNum = 1;
                this.lizhiPeople();
            },
            toPeopleJiaojie(row) {
                //离职清单弹框点击去离职交接详情
                this.lizhixiangqingPeopleShow = true;
            },
            peoplenone() {
                this.lizhixiangqingPeopleShow = false;
            },
            seletPeople() {
                //删除离职人员
                if (this.peopleSelectList.length > 0) {
                    this.sliceILizhi = true;
                } else {
                    this.sliceIshhow = true;
                    this.titlename = "删除确认";
                    this.title = "请选择需要操作的数据";
                }
            },
            sliceILizhicancel() {
                this.sliceILizhi = false;
            },
            sliceILizhiok() {
                let list = [];
                let lognameList = [];
                for (let i = 0; i < this.peopleSelectList.length; i++) {
                    list.push(this.peopleSelectList[i].id);
                    lognameList.push(this.peopleSelectList[i].loginName);
                }
                let params = {
                    idList: list.join(","),
                    loginNameList: lognameList.join(",")
                };
                this.isiconfontshow = true;
                deleteSeparatedEmployee(params).then(res => {
                    if (res.data.code == 1) {
                        this.isiconfontshow = false;
                        this.alertTitleIshow = true;
                        setTimeout(() => {
                            this.alertTitleIshow = false;
                        }, 2000);
                        this.sliceILizhi = false;
                        this.peopleSelectList = [];
                        this.peopleselectNum = this.peopleSelectList.length;
                        this.lizhiPeople(1);
                    } else {
                        this.isiconfontshow = false;
                        this.alertTitle = res.data.msg;
                        this.alertTitleIshow2 = true;
                        setTimeout(() => {
                            this.alertTitleIshow2 = false;
                        }, 2000);
                    }
                });
            },
            peoplePiLiang() {
                //离职人员批量导出
                let list = [];
                let baseUrl = sessionStorage.getItem("baseUrl");

                let token = JSON.parse(sessionStorage.getItem("login")).token || "";
                if (this.peopleSelectList.length > 0) {
                    for (let i = 0; i < this.peopleSelectList.length; i++) {
                        list.push(this.peopleSelectList[i].id);
                    }
                }
                // window.location.href = baseUrl + '/wts/admin/struc/exportSeparatedEmployeeList?idList=' + list.join(',') + "&token=" + token;
            },
            changePeoplecurrent(page) {
                //离职人员换页
                this.peoplepageNum = page;
                this.peopleSelectList = [];
                this.peopleselectNum = this.peopleSelectList.length;
                this.lizhiPeople();
            },
            changesortPeople(item) {
                //排序
                this.isAsc = item.order;
                this.orderField = item.key;
                if (item.order == "normal") {
                    this.isAsc = "";
                    this.orderField = "";
                }
                this.peopleSelectList = [];
                this.peopleselectNum = this.peopleSelectList.length;
                this.lizhiPeople(1);
            },
            selectChangepeople(item) {
                //离职员工多选
                this.peopleSelectList = item;
                this.peopleselectNum = this.peopleSelectList.length;
            },
            lizhiPeople(num) {
                //离职成员展示的页面并请求离职员工接口
                this.current = 1;
                this.lizhiPeopleShow = false;
                if (num) {
                    this.peoplepageNum = 1;
                }
                let params = {
                    pageNum: this.peoplepageNum,
                    pageSize: this.peoplepageSize,
                    orderField: this.orderField,
                    isAsc: this.isAsc
                };
                this.isiconfontshow = true;
                getSeparatedEmployeeList(params).then(res => {
                    if (res.data.code == 1) {
                        this.isiconfontshow = false;
                        this.people = res.data.data.list;
                        this.peoplepageNum = res.data.data.pageNum;
                        if (res.data.data.pageNum == 0) {
                            this.peoplepageNum = 1;
                        }
                        this.peopletotal = res.data.data.total;
                    }
                });
            },
            piLiang() {
                //批量导出
                let userIdLists = [];
                let token = JSON.parse(sessionStorage.getItem("login")).token || "";
                let baseUrl = sessionStorage.getItem("baseUrl");
                if (this.selectList.length > 0) {
                    for (let i = 0; i < this.selectList.length; i++) {
                        userIdLists.push(this.selectList[i].userId);
                    }
                }
                let params = {
                    structureId: this.titleObj.id,
                    isAll: this.singleitem,
                    userIdList: userIdLists.join(",") //用户id数组拼接
                };
                // window.location.href = baseUrl + '/wts/admin/struc/exportUserList?userIdList=' + userIdLists.join(',') + "&structureId=" + this.titleObj.id + '&isAll=' + this.singleitem + "&token=" + token;
            },
            toJiaojie(item) {
                //点击离职交接
                this.lizhiShow = true;
            },
            getSubordinateLists(id) {
                //获取下级部门列表
                this.lizhiPeopleShow = true;
                let params = {
                    structureId: id || 1
                };
                this.isiconfontshow = true;
                getSubordinateList(params).then(res => {
                    if (res.data.code == 1) {
                        this.isiconfontshow = false;
                        this.clubList = res.data.data.childList || [];
                        this.titleObj = res.data.data.current; //下级部门列表
                        this.titleList = res.data.data.parentList;
                        this.titleList.reverse();
                    } else {
                        this.isiconfontshow = false;
                    }
                });
            },
            getUserListByStructureIds(id, num) {
                //获取表格
                this.toChildIdnum = id;
                if (num) {
                    this.current = num;
                }
                this.selectList = [];
                this.selectNum = this.selectList.length;
                let params = {
                    structureId: this.toChildIdnum || 1,
                    isAll: this.singleitem, //是否显示所有下级部门人员列表,1-是,0-否
                    pageNum: this.current,
                    pageSize: this.pageSize,
                    orderField: this.paixuKey,
                    isAsc: this.paixuSc
                };
                this.isiconfontshow = true;
                getUserListByStructureId(params).then(res => {
                    if (res.data.code == 1) {
                        this.isiconfontshow = false;
                        this.data = res.data.data.list || [];
                        this.tableObj = res.data.data || {};
                        this.current = this.tableObj.pageNum;
                        if (this.tableObj.pageNum == 0) {
                            this.current = 1;
                        }
                    } else {
                        this.isiconfontshow = false;
                        this.alertTitle = res.data.msg;
                        this.alertTitleIshow2 = true;
                        setTimeout(() => {
                            this.alertTitleIshow2 = false;
                        }, 2000);
                    }
                });
            },
            changecurrent(page) {
                //切换页码
                this.current = page;
                this.getUserListByStructureIds(this.toChildId);
                this.selectList = [];
                this.selectNum = this.selectList.length;
            },
            selectChange(list) {
                //btable选择
                this.selectList = list;
                this.selectNum = this.selectList.length;
            },
            changesort(column) {
                //排序点击
                this.paixuKey = column.key;
                this.paixuSc = column.order;
                this.selectList = [];
                this.selectNum = this.selectList.length;
                if (column.order == "normal") {
                    this.paixuSc = "";
                    this.paixuKey = "";
                }
                this.getUserListByStructureIds(this.toChildId, 1);
            },
            lizhiSure(res) {
                this.lizhiShow = res;
            },
            sliceIMember() {
                //成员离职
                if (this.selectList.length > 0) {
                    this.title = "选中的成员确实需要执行离职操作？";
                } else {
                    this.title = "请选择需要操作的数据";
                }
                this.sliceIshhow = true;
                this.liZhidata.data = "";
                this.titlename = "成员离职";
            },
            sliceIBumencancel() {
                this.sliceIBumen = false;
            },
            sliceIBumenok() {
                //删除部门确认
                let params = {
                    structureId: this.titleObj.id
                };
                this.isiconfontshow = true;
                deleteStructure(params).then(res => {
                    if (res.data.code == 1) {
                        this.isiconfontshow = false;
                        this.alertTitleIshow = true;
                        setTimeout(() => {
                            this.alertTitleIshow = false;
                        }, 2000);
                        this.bumen = false;
                        this.$emit("gettrees", true, this.clearParentId);
                        this.sliceIBumen = false;
                    } else {
                        this.isiconfontshow = false;
                        this.alertTitle = res.data.msg;
                        this.alertTitleIshow2 = true;
                        setTimeout(() => {
                            this.alertTitleIshow2 = false;
                        }, 2000);
                    }
                });
            },
            changgesingle(item) {
                //显示下级多有部门人员
                if (this.single) {
                    this.singleitem = 1;
                } else {
                    this.singleitem = 0;
                }
                this.getUserListByStructureIds(this.toChildId);
            },
            handleReset(name) {
                //选择离职日期确认取消
                this.$refs[name].resetFields();
                this.cancel();
            },
            handleSubmit(name) {
                //选择离职日期确认
                if (this.title == "请选择需要操作的数据") {
                    this.ok();
                } else {
                    if (this.liZhidata.data !== "") {
                        var d = Date(this.liZhidata.data);
                        this.liZhidata.data =
                            d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();
                    }
                    this.$refs[name].validate(valid => {
                        if (valid) {
                            this.ok();
                        }
                    });
                }
            },
            ok(index) {
                //确定
                if (this.selectList.length > 0 && this.liZhidata.data !== "") {
                    let data = [];
                    for (let i = 0; i < this.selectList.length; i++) {
                        data.push(this.selectList[i].userId);
                    }
                    let params = {
                        userIdList: data.join(","),
                        separatedDate: this.liZhidata.data
                    };
                    this.isiconfontshow = true;
                    addSeparatedEmployee(params).then(res => {
                        if (res.data.code == 1) {
                            this.isiconfontshow = false;
                            this.getUserListByStructureIds(this.titleObj.id); //添加成员成功后重新调取人员列表
                            this.sliceIshhow = false;
                            this.alertTitleIshow = true; //弹框提示
                            setTimeout(() => {
                                this.alertTitleIshow = false;
                            }, 2000);
                        } else {
                            this.isiconfontshow = false;
                            this.alertTitle = res.data.msg;
                            this.alertTitleIshow2 = true;
                            setTimeout(() => {
                                this.alertTitleIshow2 = false;
                            }, 2000);
                        }
                    });
                } else {
                    this.sliceIshhow = false;
                }
            },
            cancel() {
                //取消
                this.bumen = false;
                this.sliceIshhow = false;
            }
        }
    };
</script>

<style lang="scss" scoped="" type="text/css">
    @import "../css/conmmon.scss";
    @import "../font/iconfont.css";
    .selectdata {
        width: 100%;
        .numtitle {
            padding-left: 35px;
        }
    }
    
    .organizationContentOne {
        height: 100%;
        overflow: hidden;
        overflow-y: scroll;
        overflow-y: visible;
        font-size: 13px;
        font-family: SimHei;
        padding: 15px;
        padding-bottom: 30px;
        color: #7f7f7f;
        .title-title-margin {
            margin-top: 15px;
        }
        .page-div {
            width: 100%;
            margin-top: 15px;
            position: fixed;
            background: #fff;
            width: calc(100% - 500px);
            height: 60px;
            z-index: 99;
            bottom: 0;
            padding-top: 15px;
            .page-div-left {
                float: left;
                padding: 5px 10px;
            }
            .page-div-lefts {
                border-right: 1px solid #d7d7d7;
                margin-right: 15px;
            }
            .page-div-page {
                float: right;
                margin-right: 15px;
            }
        }
        .organizationContentOne-tablie {
            width: 100%;
            margin-bottom: 60px;
        }
        .title-title {
            height: 30px;
            line-height: 30px;
            margin-bottom: 15px;
            .title {
                font-size: 16px;
                font-weight: 600;
                margin-right: 15px;
                line-height: 20px;
                display: inline-block;
                height: 100%;
            }
            .ivu-btn-success {
                border-color: #53cac3;
                color: #7f7f7f;
                height: 30px;
                margin-top: -5px;
            }
            .title-btn {
                float: right;
            }
        }
        .title-cont {
            display: inline-block;
            margin-bottom: 15px;
            margin-left: 15px;
            .title-icon {
                margin-left: 5px;
            }
            .titleactive {
                color: #53cac3;
            }
            .title-bu {
                color: #53cac3;
            }
        }
        .buttom-bu {
            display: block;
            width: 100%;
            padding-left: 15px;
            padding-right: 60px;
            height: 200px;
            overflow: hidden;
            overflow-y: scroll;
            overflow-y: visible;
            li {
                cursor: pointer;
                display: block;
                width: 100%;
                height: 40px;
                line-height: 40px;
                padding-left: 15px;
                padding-right: 10px;
                border-bottom: 1px solid #d7d7d7;
                .name {
                    display: inline-block;
                    width: 150px;
                }
                .title-icon {
                    float: right;
                    margin-top: 15px;
                    font-size: 18px;
                }
            }
            .buttom-bu-img {
                width: 200px;
                height: 100px;
                margin: 0 auto;
                display: block;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/shezhi/organizationContentOne.vue